module.exports = __webpack_public_path__ + "img/icon_highlight_lanhou.d3e79a5f.png";